import { render, staticRenderFns } from "./VTitle.vue?vue&type=template&id=2f277ed5&scoped=true"
import script from "./VTitle.vue?vue&type=script&lang=js"
export * from "./VTitle.vue?vue&type=script&lang=js"
import style0 from "./VTitle.vue?vue&type=style&index=0&id=2f277ed5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f277ed5",
  null
  
)

export default component.exports